import { render, staticRenderFns } from "./NotaFiscalStatus.vue?vue&type=template&id=5a4f1b02&scoped=true&"
import script from "./NotaFiscalStatus.vue?vue&type=script&lang=js&"
export * from "./NotaFiscalStatus.vue?vue&type=script&lang=js&"
import style0 from "./NotaFiscalStatus.vue?vue&type=style&index=0&id=5a4f1b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4f1b02",
  null
  
)

export default component.exports